import { render, staticRenderFns } from "./GraphIndexWidget.vue?vue&type=template&id=56a99112&scoped=true"
import script from "./GraphIndexWidget.vue?vue&type=script&lang=js"
export * from "./GraphIndexWidget.vue?vue&type=script&lang=js"
import style0 from "./GraphIndexWidget.vue?vue&type=style&index=0&id=56a99112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a99112",
  null
  
)

export default component.exports